// assets/media-library.js
class mediaPreview {
  constructor() {
    this.modal = document.querySelector('.media-preview-modal');
    this.previewContainer = this.modal.querySelector('.media-preview-modal__preview');
    this.loadingElement = this.modal.querySelector('.media-preview-modal__loading');
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.querySelectorAll('.media-card__preview-button').forEach(button => {
      button.addEventListener('click', (e) => this.showPreview(e));
    });

    this.modal.querySelector('.media-preview-modal__close').addEventListener('click', () => this.hidePreview());
    this.modal.querySelector('.media-preview-modal__overlay').addEventListener('click', () => this.hidePreview());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.hidePreview();
    });
  }

  async showPreview(event) {
    const url = event.currentTarget.dataset.previewUrl;
    const fileType = this.getFileType(url);

    document.body.style.overflow = 'hidden';
    this.modal.setAttribute('aria-hidden', 'false');
    this.showLoading();

    try {
      let content;
      switch (fileType) {
        case 'pdf':
          content = `<iframe src="${url}" width="100%" height="100%" frameborder="0"></iframe>`;
          break;
        case 'mp4':
        case 'mov':
        case 'webm':
          content = `
            <video controls playsinline>
              <source src="${url}" type="video/${fileType}">
              Your browser does not support the video tag.
            </video>`;
          break;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          const img = await this.loadImage(url);
          content = img.outerHTML;
          break;
        default:
          content = '<p>Preview not available for this file type</p>';
      }
      
      this.previewContainer.innerHTML = content;

      const video = this.previewContainer.querySelector('video');
      if (video) {
        this.modal.addEventListener('click', () => video.pause(), { once: true });
      }
    } catch (error) {
      this.previewContainer.innerHTML = '<p>Error loading preview</p>';
    }

    this.hideLoading();
  }

  hidePreview() {
    document.body.style.overflow = '';
    const video = this.previewContainer.querySelector('video');
    if (video) video.pause();
    
    this.modal.setAttribute('aria-hidden', 'true');
    this.previewContainer.innerHTML = '';
  }

  showLoading() {
    this.loadingElement.style.display = 'block';
    this.previewContainer.style.display = 'none';
  }

  hideLoading() {
    this.loadingElement.style.display = 'none';
    this.previewContainer.style.display = 'block';
  }

  getFileType(url) {
    return url.split('.').pop().toLowerCase();
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }
}

class mediaManager {
  constructor() {
    this.medias = Array.from(document.querySelectorAll('.media-card'));
    this.grid = document.querySelector('.media-library__grid');
    this.selectedFiles = new Set();
    this.downloadButton = document.querySelector('.download-selected');
    this.selectedCount = document.querySelector('.selected-count');
    
    this.setupControls();
    this.setupEventListeners();
    this.initializeFileSizes();
  }

    formatFileSize(bytes) {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // Add new method to fetch file size
  async fetchFileSize(url) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const size = response.headers.get('content-length');
      return size ? this.formatFileSize(parseInt(size)) : 'Unknown size';
    } catch (error) {
      console.error('Error fetching file size:', error);
      return 'Unknown size';
    }
  }

  // Add new method to initialize file sizes
  async initializeFileSizes() {
    const sizePromises = this.medias.map(async (media) => {
      const fileUrl = media.querySelector('.media-checkbox').dataset.fileUrl;
      const sizeSpan = media.querySelector('.media-card__meta span.file-size');
      
      if (fileUrl && sizeSpan) {
        const fileSize = await this.fetchFileSize(fileUrl);
        sizeSpan.textContent = fileSize;
      }
    });

    await Promise.all(sizePromises);
  }

setupControls() {
    this.filterType = document.getElementById('filter-type');
    this.filterCategory = document.getElementById('filter-category');
  }

   setupEventListeners() {
    this.filterType.addEventListener('change', () => this.applyFilters());
    this.filterCategory.addEventListener('change', () => this.applyFilters());

    document.querySelectorAll('.media-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
    });

    this.downloadButton.addEventListener('click', () => this.handleDownload());
  }

  handleCheckboxChange(event) {
    if (event.target.checked) {
      this.selectedFiles.add(event.target.dataset.fileUrl);
    } else {
      this.selectedFiles.delete(event.target.dataset.fileUrl);
    }
    
    this.selectedCount.textContent = this.selectedFiles.size;
    this.downloadButton.disabled = this.selectedFiles.size === 0;
  }

async handleDownload() {
  const buttonText = this.downloadButton.querySelector('.button__text');
  const loadingIndicator = this.downloadButton.querySelector('.button__loading-indicator');
  
  // Show loading state
  buttonText.classList.add('hidden');
  loadingIndicator.classList.remove('hidden');
  this.downloadButton.disabled = true;

  this.showNotification('Starting download...');

  try {
    const downloads = Array.from(this.selectedFiles).map(async (fileUrl) => {
      try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const blob = await response.blob();
        const filename = fileUrl.split('/').pop();
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Download failed for:', fileUrl, error);
        this.showNotification('Error downloading file: ' + filename, 'error');
      }
    });

    await Promise.all(downloads);
    this.showNotification('Download complete!', 'success');
    
    // Clear all checkboxes
    document.querySelectorAll('.media-checkbox').forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Clear selected files set and update count
    this.selectedFiles.clear();
    this.selectedCount.textContent = '0';
    
  } catch (error) {
    console.error('Some downloads failed:', error);
    this.showNotification('Some downloads failed', 'error');
  } finally {
    // Reset button state
    buttonText.classList.remove('hidden');
    loadingIndicator.classList.add('hidden');
    this.downloadButton.disabled = true;
  }
}

showNotification(message, type = 'info') {
  const existingNotification = document.querySelector('.download-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  const notification = document.createElement('div');
  notification.className = `download-notification ${type}`;
  notification.textContent = message;
  document.body.appendChild(notification);

  setTimeout(() => notification.classList.add('active'), 10);

  setTimeout(() => {
    notification.classList.remove('active');
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}

  applyFilters() {
    const type = this.filterType.value;
    const category = this.filterCategory.value;

    this.medias.forEach(media => {
      const matchesType = type === 'all' || media.dataset.mediaType === type;
      const matchesCategory = category === 'all' || media.dataset.mediaCategory === category;
      
      if (matchesType && matchesCategory) {
        media.classList.remove('filtered');
      } else {
        media.classList.add('filtered');
      }
    });
  }


  sortmedias() {
    const sortBy = this.sortBy.value;
    const sortOrder = this.sortOrder.value;
    
    const visiblemedias = this.medias.filter(media => !media.classList.contains('filtered'));
    
    visiblemedias.sort((a, b) => {
      let valueA, valueB;
      
      switch (sortBy) {
        case 'name':
          valueA = a.querySelector('h3').textContent;
          valueB = b.querySelector('h3').textContent;
          break;
        case 'size':
          valueA = this.parseFileSize(a.querySelector('.media-card__meta span:last-child').textContent);
          valueB = this.parseFileSize(b.querySelector('.media-card__meta span:last-child').textContent);
          break;
        case 'type':
          valueA = a.dataset.mediaType;
          valueB = b.dataset.mediaType;
          break;
        case 'category':
          valueA = a.dataset.mediaCategory;
          valueB = b.dataset.mediaCategory;
          break;
        default:
          valueA = valueB = '';
      }
      
      if (sortOrder === 'desc') {
        [valueA, valueB] = [valueB, valueA];
      }
      
      return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    });
    
    visiblemedias.forEach(media => this.grid.appendChild(media));
  }

  parseFileSize(size) {
    const sizeNum = parseFloat(size);
    if (size.includes('KB')) return sizeNum * 1024;
    if (size.includes('MB')) return sizeNum * 1024 * 1024;
    if (size.includes('GB')) return sizeNum * 1024 * 1024 * 1024;
    return sizeNum;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new mediaPreview();
  new mediaManager();
});